import RoundProduct from "../components/SingleProduct/RoundProduct.jsx";
import { useEffect, useState, useContext } from "react";
import sendRequest from "hooks/useAxios";
import toast from "react-hot-toast";
import toastFunction from "utils/toast.jsx";
import { sendRequestAPI2 } from "hooks/useAxios";
import CartItemsContext from "context/CardItems";
import { sendRequestAPI4 } from "hooks/useAxios";
import EditProductAdmin from "../components/SingleProduct/EditProductAdmin.jsx";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { debounce } from "lodash";
import Loader from "utils/Loader.jsx";
import logo from "assets/images/sitelogo.svg";
const SingleProductRound = ({ logo }) => {
  let id = useParams();
  const { items, setItems, editCartItems, updateCartItemsFunc, length } =
    useContext(CartItemsContext);
  const [commentList, setCommentList] = useState([]);
  const [productInfo, setProductInfo] = useState({
    business: {},
    product: [
      {
        bodytxt: "",
        url: "",
        title: "",
        rating_count: "",
        avg_rating: "",
        interest_rates: 1,
      },
    ],
    renge: [
      {
        to_count: "",
        from_count: "",
        to_price: "",
        from_price: "",
        saled_count: 0,
      },
      {
        to_count: "",
        from_count: "",
        to_price: "",
        from_price: "",
        saled_count: 0,
      },
      {
        to_count: "",
        from_count: "",
        to_price: "",
        from_price: "",
        saled_count: 0,
      },
    ],
  });
  const [sameProduct, setSameProduct] = useState([]);
  const [eTxt, setErrorTxt] = useState(false);
  const [maxPrice, setMaxPrice] = useState("");
  const [hashtagId, setHashtagId] = useState("");
  const [count, setCount] = useState({ step: "", max: "", min: "" });
  const [updater, setUpdater] = useState(true);
  const [loading, setLoading] = useState(true);
  const [firstProduct, setFirstProduct] = useState({ product: [] });
  const auth = useContext(WithAuthentication);
  const selectedProduct = (productId, businesseId) => {
    sendRequest("Find_comments", {
      tbl_name: "left join,users,muid,id",
      conditions: `product_id/=/${productId}@@status/!=/2@@businessId/=/${businesseId}`,
    }).then((data) => {
      setCommentList(data.data);
    });
    let temp = [];
    sendRequest("products_link", {
      productId: productId,
      businesseId: businesseId,
    }).then((item) => {
      // console.log("item.data.links", item.data.links);
      item.data.links != null && setProductInfo(item.data.links);
      item.data.links != null &&
        setMaxPrice(() => {
          let x = item.data.links.product[0];
          let y =
            (+x.default_price * +x.Interest_rates) / 100 + +x.default_price;
          return y;
        });
      // for (let i = 0; i < item.data.links.hashtags.length; i++) {
      //   temp.push(item.data.links.hashtags[i].hashtag_id);
      //   setHashtagId(temp.toString());
      // }
      for (let i = 0; i < 3; i++) {
        if (
          item.data.links.renge.length > 0 &&
          item.data.links.renge[i].is_active == "1"
        ) {
          setCount({
            step: item.data.links.renge[i].step,
            max: item.data.links.renge[i].max_num,
            min: item.data.links.renge[i].min_num,
          });
        }
      }
    });
  };
  const addCartItem = (productId, SaleConditionId, isGroup, productList) => {
    if (auth.userInfo.userType == -1) {
      toastFunction("error", "لطفا ابتدا لاگین کنید.");
    } else {
      sendRequestAPI2("addcartitem", {
        product_id: productId,
        SaleConditionId: SaleConditionId,
        isGroup: isGroup,
      }).then((data) => {
        if (data.data.status == 1) {
          toastFunction("success", "محصول با موفقیت به سبد خرید اضافه شد.");

          updateCartItemsFunc();
        } else if (data.data.status == -3) {
          toastFunction("error", "موجودی محصول به پایان رسیده است.");
        } else if (data.data.status == -2) {
          toastFunction(
            "error",
            "سقف مجاز شما در خرید این محصول به پایان رسیده است."
          );
        } else if (data.data.status == -5) {
          toastFunction(
            "error",
            "در هر خرید از محصولات گروهی فقط امکان خرید یک کالا وجود دارد."
          );
        } else {
          toastFunction(
            "error",
            "متاسفانه مشکلی در افزودن به سبد خرید به وجود آمده است."
          );
        }
      });
    }
  };
  const same = debounce((title, hashtag, id) => {
    sendRequestAPI4("sameproduct", {
      title: title,
      hashtags: hashtag,
      single: id.productType == 1 ? 1 : 0,
      PBLid: id,
    }).then((item) => {
      setSameProduct([
        ...item.data.items,
        { ...firstProduct, products_id: firstProduct.product[0]?.id },
      ]);
      setLoading(false);
      // console.log("ppppp", item.data.items);
    });
  }, 2500);

  useEffect(() => {
    setLoading(true);

    same(firstProduct?.product[0]?.title, hashtagId, firstProduct.id);
  }, [firstProduct, hashtagId]);

  useEffect(() => {
    let temp = [];
    async function loadPage() {
      await sendRequest("Find_comments", {
        tbl_name: "left join,users,muid,id",
        conditions: `product_id/=/${id.productId}@@status/!=/2@@businessId/=/${id.businessId}`,
      }).then((data) => {
        setCommentList(data.data);
      });
      await sendRequest("products_link", {
        productId: id.productId,
        businesseId: id.businessId,
      }).then((item) => {
        // console.log("item.data.links", item.data.links);

        if (item.data.links != null || item.data.links != undefined) {
          setFirstProduct(item.data.links);
          setProductInfo(item.data.links);
        } else {
          setErrorTxt(true);
        }

        item.data.links != null &&
          setMaxPrice(() => {
            let x = item.data.links.product[0];
            let y =
              (+x.default_price * +x.Interest_rates) / 100 + +x.default_price;
            return y;
          });
        for (let i = 0; i < item.data.links.hashtags.length; i++) {
          temp.push(item.data.links.hashtags[i].hashtag_id);
          setHashtagId(temp.toString());
        }
        for (let i = 0; i < 3; i++) {
          if (
            item.data.links.renge.length > 0 &&
            item.data.links.renge[i].is_active == "1"
          ) {
            setCount({
              step: item.data.links.renge[i].step,
              max: item.data.links.renge[i].max_num,
              min: item.data.links.renge[i].min_num,
            });
          }
        }
      });
      setLoading(false);
    }
    loadPage();
  }, [updater]);

  // console.log("parentInfo", productInfo);
  // console.log("productType", id);
  // console.log("auth", auth);
  // console.log("same", sameProduct);
  console.log("firstProduct", firstProduct);
  return (
    <>
      {loading && <Loader />}
      <div className="m-3 d-flex product-button">
        <EditProductAdmin
          productDetail={productInfo}
          maxPrice={maxPrice}
          setUpdater={setUpdater}
        />
      </div>
      {eTxt == false &&
      ((id.productType == "1" && productInfo.is_single == "1") ||
        (id.productType == "2" && productInfo.have_group_sale == "1")) ? (
        <RoundProduct
          productInfo={productInfo} //ابجکت اطلاعات محصول
          commentList={commentList} //لیست کامنتها
          sameProduct={sameProduct} //محصولات مشابه
          maxPrice={maxPrice} //حدکثر قیمت محصول(قیمت اصلی+درصد سود)
          selectedProduct={selectedProduct} //func برای تغییر اطلاعات محصول با کلیک
          addCartItem={addCartItem}
          setUpdater={setUpdater}
          productType={id.productType}
          firstProduct={firstProduct}
          logo={logo}
        />
      ) : (
        <div className="d-flex">
          <p className="mx-auto">
            در حال حاضر محصولی با این مشخصات موجود نیست.
          </p>
        </div>
      )}
    </>
  );
};

export default SingleProductRound;
